module.exports = __webpack_public_path__ + "static/media/Media3.43584930.jpg";